import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { vatSituationsService } from "../services/vatSituation.service";

export const fetchVatSituations = createAsyncThunk("vatSituation/fetchAll", async (_, thunkAPI) => {
    try {
        return await vatSituationsService.getVatSituations();
    } catch (err) {
        return thunkAPI.rejectWithValue("Failed to fetch Vat Situations.");
    }
});

export const fetchVatSituationById = createAsyncThunk("vatSituation/fetchById", async (id, thunkAPI) => {
    try {
        return await vatSituationsService.getVatSituationById(id);
    } catch (err) {
        return thunkAPI.rejectWithValue("Failed to fetch Vat Situation");
    }
});

export const addVatSituation = createAsyncThunk("vatSituation/add", async (vatSituation, thunkAPI) => {
    try {
        return await vatSituationsService.createVatSituation(vatSituation);
    } catch (err) {
        return thunkAPI.rejectWithValue("Failed to create Vat Situation");
    }
});

export const editVatSituation = createAsyncThunk("vatSituation/edit", async ({ id, vatSituation }, thunkAPI) => {
    try {
        return await vatSituationsService.updateVatSituation(id, vatSituation);
    } catch (err) {
        return thunkAPI.rejectWithValue("Failed to update Vat Situation");
    }
});

export const removeVatSituation = createAsyncThunk("vatSituation/remove", async (id, thunkAPI) => {
    try {
        await vatSituationsService.deleteVatSituation(id);
        return id;
    } catch (err) {
        return thunkAPI.rejectWithValue("Failed to delete Vat Situation");
    }
});

const vatSituationSlice = createSlice({
    name: "vatSituation",
    initialState: { vatSituations: [], totalCount: 0, vatSituation: null, loading: false, error: null, showModal: false, showDeleteModal: false },
    reducers: {
        openModal: (state) => { state.showModal = true },
        closeModal: (state) => { state.showModal = false },
        openDeleteModal: (state) => { state.showDeleteModal = true },
        closeDeleteModal: (state) => { state.showDeleteModal = false }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVatSituations.pending, (state) => { state.loading = true; state.error = null })
            .addCase(fetchVatSituations.fulfilled, (state, action) => { state.loading = false; state.vatSituations = action.payload })
            .addCase(fetchVatSituations.rejected, (state, action) => { state.loading = false; state.error = action.payload })
            .addCase(fetchVatSituationById.fulfilled, (state, action) => { state.vatSituation = action.payload })
            .addCase(addVatSituation.pending, (state) => { state.loading = true })
            .addCase(addVatSituation.fulfilled, (state, action) => {
                state.vatSituations = [action.payload, ...state.vatSituations]
                state.loading = false
                state.showModal = false
            })
            .addCase(editVatSituation.pending, (state) => { state.loading = true })
            .addCase(editVatSituation.fulfilled, (state, action) => {
                const edited = action.meta.arg;
                state.vatSituations = state.vatSituations.map((v) =>
                    v.vatSituationId === edited.id ? { ...edited.vatSituation, vatSituationId: edited.id } : v
                );
                state.loading = false
                state.showModal = false
            })
            .addCase(removeVatSituation.pending, (state) => { state.loading = true })
            .addCase(removeVatSituation.fulfilled, (state, action) => {
                state.vatSituations = state.vatSituations.filter((s) => s.vatSituationId !== action.payload);
                state.loading = false
                state.showDeleteModal = false
            })
            .addCase(removeVatSituation.rejected, (state) => { state.loading = false });
    },
});

export const { openModal, closeModal, openDeleteModal, closeDeleteModal } = vatSituationSlice.actions;
export default vatSituationSlice.reducer;